import { patientEventsApi } from './index'

export default patientEventsApi.middleware
